import {Button, Card, CardContent, FormControl, Grid, TextField} from '@material-ui/core'
import {Autocomplete, CircularProgressBar, LinearProgressBar} from 'app/Components'
import {onKeyDown} from 'external-lib/utils/helpers'
import {Formik} from 'formik'
import {GroupClass} from 'lib/groupClass'
import {isLoading, isProcessing} from 'lib/progress'
import {Source} from 'lib/select'
import {State} from 'lib/store'
import React from 'react'
import {connect, MapStateToProps} from 'react-redux'
import * as Yup from 'yup'

type StateToProps = {
    readonly isLoading: boolean
    readonly isProcessing: boolean
}

type FormControlProps = {
    initialValues: GroupClass
    handleSubmit: (groupClass: GroupClass) => void
}

const Schema = Yup.object().shape({
    weeklySessions: Yup.number()
        .required('Pole jest wymagane')
        .min(1, 'Minimalna dozwolona wartość to 1'),
    subject: Yup.string()
        .required('Pole jest wymagane'),
    teacher: Yup.string()
        .required('Pole jest wymagane'),
    duration: Yup.string()
        .required('Pole jest wymagane'),
})

class FormComponent extends React.Component<FormControlProps & StateToProps> {
    public render = () =>
        <>
            {
                this.props.isLoading
                    ? <CircularProgressBar/>
                    : <Formik
                        initialValues={this.props.initialValues}
                        validationSchema={Schema}
                        validateOnChange={false}
                        onSubmit={values => this.props.handleSubmit(values)}
                    >
                        {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              setFieldValue
                          }) => (
                            <form onSubmit={handleSubmit} onKeyDown={onKeyDown}>

                                <Card variant="outlined">
                                    <CardContent>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <TextField
                                                        error={Boolean(errors.weeklySessions && touched.weeklySessions)}
                                                        label="Ilość w tygodniu *"
                                                        id="weeklySessions"
                                                        name="weeklySessions"
                                                        variant="outlined"
                                                        inputProps={{
                                                            maxLength: 2,
                                                        }}
                                                        value={values.weeklySessions}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={errors.weeklySessions}
                                                        type="number"
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Zajęcia *"}
                                                        field={'subject'}
                                                        source={Source.SUBJECTS}
                                                        value={values.subject}
                                                        error={Boolean(errors.subject && touched.subject)}
                                                        setFieldValue={setFieldValue}
                                                        helperText={errors.subject as string}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Specjalista *"}
                                                        field={'teacher'}
                                                        source={Source.SPECIALISTS}
                                                        value={values.teacher}
                                                        error={Boolean(errors.teacher && touched.teacher)}
                                                        setFieldValue={setFieldValue}
                                                        helperText={errors.teacher as string}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Czas trwania *"}
                                                        field={'duration'}
                                                        source={Source.CLASS_DURATION}
                                                        value={values.duration}
                                                        error={Boolean(errors.duration && touched.duration)}
                                                        setFieldValue={setFieldValue}
                                                        helperText={errors.duration as string}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => handleSubmit()}
                                                    disabled={this.props.isProcessing}
                                                >
                                                    Zapisz
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </CardContent>
                                </Card>
                            </form>
                        )}
                    </Formik>
            }
        </>
}

const mapStateToProps: MapStateToProps<StateToProps, {}, State> = state => ({
    isLoading: isLoading(state),
    isProcessing: isProcessing(state),
})

export const Form = connect(mapStateToProps)(FormComponent)